import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppData } from '@shared/models/appdata.model';
import { Observable, of } from 'rxjs';
import { ContractResponse, GenerateSmsContractRequest } from '../models/contract.model';
import { GenerateEquipmentUpgradeSmsRequest } from '../models/contract-information.model';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContractService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  private apiUrl = this.appData.apiUrl + '/api';

  generateEquipmentUpgradeContractLinkSms(contractInfo: GenerateEquipmentUpgradeSmsRequest): Observable<string> {
    const url = `${this.apiUrl}/v1/contract/generate-equipment-upgrade-contract-link-sms`;
    return this.http.post<string>(url, contractInfo);
  }

  getContract(orderCaptureId: number): Observable<ContractResponse> {
    const url = `${this.apiUrl}/v1/contract?orderCaptureId=${orderCaptureId}`;
    return this.http.get<ContractResponse>(url).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 404) {
          return of(undefined);
        }
        throw error;
      })
    );
  }

  generatePaperContract(orderCaptureId: number): Observable<string> {
    const url = `${this.apiUrl}/v1/contract/${orderCaptureId}/paper`;
    return this.http.put<string>(url, null);
  }

  generateOtherContract(orderCaptureId: number): Observable<string> {
    const url = `${this.apiUrl}/v1/contract/${orderCaptureId}/other`;
    return this.http.put<string>(url, null);
  }

  generateSmsContract(orderCaptureId: number, msisdn: string): Observable<string> {
    const generateSmsContractRequest: GenerateSmsContractRequest = { phoneNumber: msisdn };
    const url = `${this.apiUrl}/v1/contract/${orderCaptureId}/sms`;
    return this.http.put<string>(url, generateSmsContractRequest);
  }

  sendOrderSummarySms(orderCaptureId: number): Observable<Object> {
    const url = `${this.apiUrl}/v1/contract/send-order-summary-sms?orderCaptureId=${orderCaptureId}`;
    return this.http.post(url, null);
  }

  getPdfContract(contractId: string): Observable<Object> {
    const getPdfContractV2Request = { responseType: 'blob' as 'json' };
    const url = `${this.apiUrl}/v2/contract/${contractId}/pdf`;
    return this.http.get(url, getPdfContractV2Request);
  }
}
